export default __webpack_public_path__ + "assets/particle-a46f6119b60e1ae41d01b0c40394b4a5.svg";